module.exports = __webpack_public_path__ + "static/influencer-dc9c0441ff266cf483e07d26319e6075.jpg";